<template>
  <transition name="modal--fade">
    <div class="modal" v-if="isOpen">
      <div class="modal__overlay" v-if="!!lightbox"></div>
      <div class="modal__wrapper" :style="{width: width}">
        <Heading class="modal__wrapper__title" level="h4" v-if="!!title">{{title}}</Heading>
        <div class="modal__wrapper__content" v-if="!!$scopedSlots['default']">
          <slot name="default"></slot>
        </div>
        <div class="modal__wrapper__actions" v-if="!!primaryButton || !!secondaryButton">
          <Button
            v-if="!!primaryButton"
            variation="secondary"
            size="medium"
            class="modal__wrapper__actions__button"
            @click="onClickPrimaryButton"
          >{{primaryButton}}</Button>
          <Button
            v-if="!!secondaryButton"
            variation="secondary"
            outline
            class="modal__wrapper__actions__button"
            @click="onClickSecondaryButton"
          >{{secondaryButton}}</Button>
        </div>
        <button v-if="!!close" type="button" class="modal__wrapper__close-icon" @click="onClose">
          <Icon name="close" size="sm" color="gray"/>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from '../Icon/Icon.vue';
import Heading from '../Typography/Heading.vue';
import Button from '../Button/Button.vue';
export default {
  name: "Modal",
  status: "prototype",
  release: "1.0.0",
  components: { Icon, Heading, Button },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    close: {
      type: Boolean,
      default: false,
    },
    persist: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '520px',
    },
    lightbox: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    primaryButton: {
      type: String,
      default: null,
    },
    secondaryButton: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      lazyValue: this.value,
    }
  },
  watch: {
    value(val) {
      this.lazyValue = val;
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        this.lazyValue = val;
        this.$emit("input", val);
      }
    },
  },
  methods: {
    onClose() {
      this.isOpen = false;
      this.$emit('close');
    },
    onClickPrimaryButton(e) {
      this.$emit('primaryButtonClick', e);
    },
    onClickSecondaryButton(e) {
      this.$emit('secondaryButtonClick', e);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.modal {
  &--fade-enter-active,
  &--fade-leave-active {
    transition: opacity .3s ease;
  }
  &--fade-enter,
  &--fade-leave-to {
    opacity: 1;
  }
  &__wrapper {
    @include reset();
    position: fixed;
    padding: 30px;
    min-height: 60px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    border-radius: 5px;
    background: $color-white;
    box-shadow: 1px 2px 5px 0 rgba(119, 151, 178, 0.25);
    &::before {
      position: absolute;
      content: '';
      display: inline-block;
      width: 100%;
      height: 10px;
      top: 0;
      left: 0;
      background-color: $color-purple;
      border-radius: 5px 5px 0 0;
    }
    &__title {
      font-size: 28px;
      font-weight: normal;
      color: $color-purple;
      margin-bottom: 0;
    }
    &__content {
      padding: 15px 0;
      font-family: $font-text;
      font-size: $size-s;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.38;
      letter-spacing: normal;
      color: #000;
    }
    &__actions {
      padding-top: 15px;
      &__button {
        min-width: 200px;
        margin-bottom: 0;
        // border: 2px solid $color-purple-dark !important;
        // box-shadow: 0 5px 15px 0 rgba(152, 113, 221, 0.5) !important;
      }
    }
    &__close-icon {
      position: absolute;
      width: auto;
      height: auto;
      padding: 0;
      top: 20px;
      right: 10px;
      cursor: pointer;
      background: transparent;
      border: 0;
      &:active,
      &:focus {
        outline: none;
      }
    }
  }
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color-gray, .5);
    z-index: $z-index-modal;
  }
}
</style>
